import React from 'react';
import {
  CarFrontIcon,
  CarIcon,
  FileTextIcon,
  HomeIcon,
  HousePlusIcon,
  PackageIcon,
  ShieldCheckIcon,
} from 'lucide-react';
import type { PermissionCheck } from '@/features/auth';

export type NavItem = {
  name: string;
  icon: React.ReactNode;
  path?: string;
  requiredRoles?: string[];
  requiredPermissions?: PermissionCheck[];
  requiresInternal?: boolean;
  subItems?: {
    name: string;
    path: string;
    pro?: boolean;
    new?: boolean;
    requiredRoles?: string[];
    requiredPermissions?: PermissionCheck[];
  }[];
};

export type NavAction = {
  name: string;
  path: string;
  requiredPermissions: PermissionCheck[];
};

export const newQuoteAction: NavAction = {
  name: 'New quote',
  path: '/service-plans/new',
  requiredPermissions: [{ resource: 'quote', action: 'browse' }],
};

export const navItems: NavItem[] = [
  {
    icon: <HomeIcon />,
    name: 'Home',
    path: '/',
  },
  {
    icon: <CarFrontIcon />,
    name: 'Agreements',
    path: '/agreements',
    requiredPermissions: [
      { resource: 'quote', action: 'browse' },
      { resource: 'plan', action: 'browse' },
    ],
  },
  {
    icon: <CarIcon />,
    name: 'Vehicles',
    subItems: [
      {
        name: 'Search',
        path: '/vehicles/search',
        requiredPermissions: [{ resource: 'vehicle', action: 'browse' }],
      },
    ],
  },
];

export const adminItems: NavItem[] = [
  {
    icon: <PackageIcon />,
    name: 'Products',
    requiresInternal: true,
    subItems: [
      {
        name: 'Products',
        path: '/smr-admin/products',
        requiredPermissions: [{ resource: 'smr', action: 'product.browse' }],
      },
      {
        name: 'Plans',
        path: '/smr-admin/plans',
        requiredPermissions: [{ resource: 'smr', action: 'plan.browse' }],
      },
      {
        name: 'Items',
        path: '/smr-admin/items',
        requiredPermissions: [{ resource: 'smr', action: 'item.browse' }],
      },
      {
        name: 'Fees',
        path: '/smr-admin/fees',
        requiredPermissions: [{ resource: 'smr', action: 'fee.browse' }],
      },
      {
        name: 'Config options',
        path: '/smr-admin/config-options',
        requiredPermissions: [{ resource: 'smr', action: 'config-option.browse' }],
      },
      {
        name: 'Optional extras',
        path: '/smr-admin/addons',
        requiredPermissions: [{ resource: 'smr', action: 'addon.browse' }],
      },
      {
        name: 'Optional extra groups',
        path: '/smr-admin/addon-groups',
        requiredPermissions: [{ resource: 'smr', action: 'addon-group.browse' }],
      },
    ],
  },
  {
    icon: <HousePlusIcon />,
    name: 'Dealers',
    requiresInternal: true,
    subItems: [
      {
        name: 'Dealers',
        path: '/admin/dealers',
        requiredPermissions: [{ resource: 'dealer', action: 'browse' }],
      },
      {
        name: 'Config options',
        path: '/admin/dealers/config-options',
        requiredPermissions: [{ resource: 'dealer', action: 'config-option.browse' }],
      },
      {
        name: 'Security groups',
        path: '/admin/security-groups',
        requiredPermissions: [{ resource: 'security_group', action: 'browse' }],
      },
    ],
  },
  {
    icon: <ShieldCheckIcon />,
    name: 'Access',
    subItems: [
      {
        name: 'Users',
        path: '/admin/users',
        requiredPermissions: [{ resource: 'user', action: 'browse' }],
      },
      {
        name: 'Roles',
        path: '/admin/roles',
        requiredPermissions: [{ resource: 'role', action: 'browse' }],
      },
    ],
  },
  {
    icon: <FileTextIcon />,
    name: 'Document templates',
    path: '/admin/document-templates',
    requiredPermissions: [{ resource: 'document_template', action: 'browse' }],
  },
];
